import React, { useEffect, memo, useState } from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
import Layout from '../../../components/Layout';
import { useParams } from 'react-router-dom';
import { getCapaianPerjanjianKinerja_act } from '../../../../redux/ducks/cpk/actions'
import BackButton from '../../../components/BackButton';
import TableSakip from './TableSakip';
import TableSakinah from './TableSakinah';


const triwulan = ["tw1", "tw2", "tw3", "tw4"]
const DataCapaian_PK = (props) => {
    const { opdId, opdName, yearconfig } = useParams();
    const dataBreadcrumbs = [
        {
          title: 'Home',
          isActive: true,
          goTo: '/tahun/'+yearconfig,
        },
        {
          title: `Capaian Perjanjian Kinerja Esselon II`,
          isActive: true,
          goTo: `/tahun/${yearconfig}/cpkess/listopd`,
        },
    ]
    const [breadCrumbsData, setBreadCrumbsData] = useState();
    useEffect(() => {
        setBreadCrumbsData([...dataBreadcrumbs, {
            title: opdName,
            isActive: false,
            goTo: ''
        }])
    },[])

    useEffect(() => {
        props.getCapaianPerjanjianKinerja(opdId, yearconfig)
    },[opdId, yearconfig])
    return (
        <Layout
            loading={false}
            breadCrumbsData={breadCrumbsData}
        >
            <div
                className="bg-white rounded-lg drop-shadow-2xl py-5 px-2 w-full"
            >
                <div className="flex-grow bg-white rounded-xl py-2 relative">
                    <h1 className="text-md text-primeColor1 text-center">Capaian Perjanjian Kinerja Esselon II</h1>
                    <h1 className="mb-1 text-2xl font-bold text-primeColor1 text-center">
                    {opdName}
                    </h1>
                    <h1 className="mb-1 text-md font-bold text-primeColor1 text-center">
                    Tahun {yearconfig}
                    </h1>
                    <hr className="mb-3" />
                </div>

                { 
                    yearconfig > 2025 ?  
                    <TableSakinah dataTable={props.capaianPK.data} yearconfig={yearconfig} loading={props.capaianPK.loading} />
                    : 
                    <TableSakip dataTable={props.capaianPK.data} yearconfig={yearconfig} loading={props.capaianPK.loading} />

                }
                <div className="w-full px-10">
                </div>
            </div>
            <BackButton backLink={`/tahun/${yearconfig}/cpkess/listopd`} />
        </Layout>
    )
}



const mapStateToProps = (state) => ({
    capaianPK: state.pkState.capaianPK
})

const mapDispatchToProps = {
    getCapaianPerjanjianKinerja: getCapaianPerjanjianKinerja_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect, memo)(DataCapaian_PK)